import React, { useState } from 'react';
import { PHSHeader } from '../../components/UI/header';
import { styles } from './index.sass';
import { Input, Button, Spin, message } from 'antd';
import { crawlWix } from '../../api';

export const PublishBlog = () => {
    const [link, setLink] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const data = await crawlWix([link]);
            if (data.done) {
                message.success('Blog published successfully!');
                setLink('');
            }
        } catch (err) {
            message.error('Failed to publish blog.');
        }
        setLoading(false);
    };

    return (
        <div className={styles}>
            <PHSHeader
                hideBreadCrumb={true}
                hideSubHeader={true}
            />
            <div className='container'>
                <h2>Publish Blog</h2>
                <Spin spinning={loading} tip="Publishing...">
                    <div className='input-section'>
                        <Input
                            placeholder="Enter blog link"
                            value={link}
                            onChange={e => setLink(e.target.value)}
                            disabled={loading}
                        />
                        <Button className='button' type="primary" onClick={handleSubmit} disabled={loading}>
                            Submit
                        </Button>
                    </div>
                </Spin>
            </div>
        </div>
    )
}